import { Injectable } from '@angular/core';
import { AppInitService } from '../../services/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  emsConfig: any = {};
  constructor(private appInitService: AppInitService) {
    this.appInitService?.getConfigurableFields()?.subscribe(() => {
      Object?.keys(this.appInitService?.appConfig?.configurableFields)?.forEach(
        (ele) => {
          try {
            let temp = ele?.toString()?.trim()?.split('.');
            if (temp[0] === 'ems') {
              this.emsConfig = {
                ...this.emsConfig,
                ...{
                  [temp[1]]: this.appInitService?.appConfig?.configurableFields[
                    ele
                  ],
                },
              };
            }
          } catch (e) {}
        }
      );
    });
  }
}
